"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCUJobAlert = exports.SCUSelectBy = exports.SCUAlertSetting = exports.SCUAlertSettingMatch = exports.HueLightStateAlert = exports.SCUZoneLight = exports.SCUZone = exports.SCUPrintReportType = exports.SCUPrintType = exports.SCUPrinterConfig = exports.SCUTranslation = exports.SCUTranslationsConfig = exports.SCUTTSKey = exports.SCUTTSConfig = exports.SCUTTSVoice = exports.SCURadioType = exports.SCUClearToSend = exports.SCURampLength = exports.SCUAudioConfig = exports.SCUDayConfig = exports.SCURule = exports.SCUIODeviceRelayCondition = exports.SCUIODeviceInputCondition = exports.SCUAudioResetBehavior = exports.SCUAWSRegion = exports.SCUConfig = exports.AgencySCUConfigResponse = void 0;
var cerealParse_1 = require("../cerealParse");
var scuRuleOn_1 = require("./scuRuleOn");
var scuRuleDo_1 = require("./scuRuleDo");
var scuRuleFinally_1 = require("./scuRuleFinally");
var job_1 = require("./job");
var AgencySCUConfigResponse = /** @class */ (function () {
    function AgencySCUConfigResponse(config) {
        this.config = config;
    }
    AgencySCUConfigResponse.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new AgencySCUConfigResponse(cerealParse_1.ParseUtils.getSubobject(o, 'config', SCUConfig.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid AgencySCUConfig Response Model: " + e.message);
        }
    };
    return AgencySCUConfigResponse;
}());
exports.AgencySCUConfigResponse = AgencySCUConfigResponse;
var SCUConfig = /** @class */ (function () {
    function SCUConfig(awsRegion, rules, day, audio, tts, printers, zones, alertSettings, alertNewAssignments, alertLateAssignments, speakNewAssignments, speakLateAssignments, speakNewAssignmentsTts, speakLateAssignmentsTts, lightTimeout, pollingInterval, dayTurnoutTime, nightTurnoutTime, lightRamp, alert, sendNetworkReminders, unitWaitTime) {
        this.awsRegion = awsRegion;
        this.rules = rules;
        this.day = day;
        this.audio = audio;
        this.tts = tts;
        this.printers = printers;
        this.zones = zones;
        this.alertSettings = alertSettings;
        this.alertNewAssignments = alertNewAssignments;
        this.alertLateAssignments = alertLateAssignments;
        this.speakNewAssignments = speakNewAssignments;
        this.speakLateAssignments = speakLateAssignments;
        this.speakNewAssignmentsTts = speakNewAssignmentsTts;
        this.speakLateAssignmentsTts = speakLateAssignmentsTts;
        this.lightTimeout = lightTimeout;
        this.pollingInterval = pollingInterval;
        this.dayTurnoutTime = dayTurnoutTime;
        this.nightTurnoutTime = nightTurnoutTime;
        this.lightRamp = lightRamp;
        this.alert = alert;
        this.sendNetworkReminders = sendNetworkReminders;
        this.unitWaitTime = unitWaitTime;
    }
    SCUConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUConfig(cerealParse_1.ParseUtils.getEnum(o, 'awsRegion', SCUAWSRegion), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'rules', SCURule.parse, 'throw'), cerealParse_1.ParseUtils.getSubobject(o, 'day', SCUDayConfig.parse), cerealParse_1.ParseUtils.getSubobject(o, 'audio', SCUAudioConfig.parse), cerealParse_1.ParseUtils.getSubobject(o, 'tts', SCUTTSConfig.parse), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'printers', SCUPrinterConfig.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'zones', SCUZone.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'alertSettings', SCUAlertSetting.parse, 'throw'), cerealParse_1.ParseUtils.getBoolean(o, 'alertNewAssignments'), cerealParse_1.ParseUtils.getBoolean(o, 'alertLateAssignments'), cerealParse_1.ParseUtils.getBoolean(o, 'speakNewAssignments'), cerealParse_1.ParseUtils.getBoolean(o, 'speakLateAssignments'), cerealParse_1.ParseUtils.getStringOrNull(o, 'speakNewAssignmentsTts'), cerealParse_1.ParseUtils.getStringOrNull(o, 'speakLateAssignmentsTts'), cerealParse_1.ParseUtils.getNumber(o, 'lightTimeout'), cerealParse_1.ParseUtils.getNumber(o, 'pollingInterval'), cerealParse_1.ParseUtils.getNumber(o, 'dayTurnoutTime'), cerealParse_1.ParseUtils.getNumber(o, 'nightTurnoutTime'), cerealParse_1.ParseUtils.getNumber(o, 'lightRamp'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'alert', SCUJobAlert.parse), cerealParse_1.ParseUtils.getBooleanOrNull(o, 'sendNetworkReminders') || false, cerealParse_1.ParseUtils.getNumberOrNull(o, 'unitWaitTime')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUConfig Model: " + e.message);
        }
    };
    return SCUConfig;
}());
exports.SCUConfig = SCUConfig;
var SCUAWSRegion;
(function (SCUAWSRegion) {
    SCUAWSRegion[SCUAWSRegion["us-east-1"] = 0] = "us-east-1";
    SCUAWSRegion[SCUAWSRegion["us-east-2"] = 1] = "us-east-2";
    SCUAWSRegion[SCUAWSRegion["us-west-1"] = 2] = "us-west-1";
    SCUAWSRegion[SCUAWSRegion["us-west-2"] = 3] = "us-west-2";
})(SCUAWSRegion = exports.SCUAWSRegion || (exports.SCUAWSRegion = {}));
var SCUAudioResetBehavior;
(function (SCUAudioResetBehavior) {
    SCUAudioResetBehavior["mute"] = "mute";
    SCUAudioResetBehavior["unmute"] = "unmute";
    SCUAudioResetBehavior["noChange"] = "noChange";
})(SCUAudioResetBehavior = exports.SCUAudioResetBehavior || (exports.SCUAudioResetBehavior = {}));
var SCUIODeviceInputCondition;
(function (SCUIODeviceInputCondition) {
    SCUIODeviceInputCondition[SCUIODeviceInputCondition["activeHigh"] = 0] = "activeHigh";
    SCUIODeviceInputCondition[SCUIODeviceInputCondition["activeLow"] = 1] = "activeLow";
})(SCUIODeviceInputCondition = exports.SCUIODeviceInputCondition || (exports.SCUIODeviceInputCondition = {}));
var SCUIODeviceRelayCondition;
(function (SCUIODeviceRelayCondition) {
    SCUIODeviceRelayCondition[SCUIODeviceRelayCondition["normallyOpen"] = 0] = "normallyOpen";
    SCUIODeviceRelayCondition[SCUIODeviceRelayCondition["normallyClosed"] = 1] = "normallyClosed";
})(SCUIODeviceRelayCondition = exports.SCUIODeviceRelayCondition || (exports.SCUIODeviceRelayCondition = {}));
var SCURule = /** @class */ (function () {
    function SCURule(id, name, enabled, timeout, on, ruleDo, ruleFinally) {
        this.id = id;
        this.name = name;
        this.enabled = enabled;
        this.timeout = timeout;
        this.on = on;
        this.ruleDo = ruleDo;
        this.ruleFinally = ruleFinally;
    }
    SCURule.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURule(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getBoolean(o, 'enabled'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'timeout'), cerealParse_1.ParseUtils.getSubobject(o, 'on', scuRuleOn_1.SCURuleOn.parse), cerealParse_1.ParseUtils.getSubobject(o, 'do', scuRuleDo_1.SCURuleDo.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'finally', scuRuleFinally_1.SCURuleFinally.parse)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURule Model: " + e.message);
        }
    };
    return SCURule;
}());
exports.SCURule = SCURule;
var SCUDayConfig = /** @class */ (function () {
    function SCUDayConfig(start, end) {
        this.start = start;
        this.end = end;
    }
    SCUDayConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUDayConfig(cerealParse_1.ParseUtils.getNumber(o, 'start'), cerealParse_1.ParseUtils.getNumber(o, 'end')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUDayConfig Model: " + e.message);
        }
    };
    return SCUDayConfig;
}());
exports.SCUDayConfig = SCUDayConfig;
var SCUAudioConfig = /** @class */ (function () {
    function SCUAudioConfig(systemVolume, toneVolume, dayRamp, nightRamp, clearToSend, resetBehavior) {
        this.systemVolume = systemVolume;
        this.toneVolume = toneVolume;
        this.dayRamp = dayRamp;
        this.nightRamp = nightRamp;
        this.clearToSend = clearToSend;
        this.resetBehavior = resetBehavior;
    }
    SCUAudioConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUAudioConfig(cerealParse_1.ParseUtils.getNumber(o, 'systemVolume'), cerealParse_1.ParseUtils.getNumber(o, 'toneVolume'), cerealParse_1.ParseUtils.getEnum(o, 'dayRamp', SCURampLength), cerealParse_1.ParseUtils.getEnum(o, 'nightRamp', SCURampLength), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'clearToSend', SCUClearToSend.parse), cerealParse_1.ParseUtils.getEnumOrNull(o, 'resetBehavior', SCUAudioResetBehavior)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAudioConfig Model: " + e.message);
        }
    };
    return SCUAudioConfig;
}());
exports.SCUAudioConfig = SCUAudioConfig;
var SCURampLength;
(function (SCURampLength) {
    SCURampLength[SCURampLength["short"] = 0] = "short";
    SCURampLength[SCURampLength["med"] = 1] = "med";
    SCURampLength[SCURampLength["long"] = 2] = "long";
    SCURampLength[SCURampLength["20s"] = 3] = "20s";
})(SCURampLength = exports.SCURampLength || (exports.SCURampLength = {}));
var SCUClearToSend = /** @class */ (function () {
    function SCUClearToSend(device, input, output, timeout, inputType, radioType) {
        this.device = device;
        this.input = input;
        this.output = output;
        this.timeout = timeout;
        this.inputType = inputType;
        this.radioType = radioType;
    }
    SCUClearToSend.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUClearToSend(cerealParse_1.ParseUtils.getString(o, 'device'), cerealParse_1.ParseUtils.getNumber(o, 'input'), cerealParse_1.ParseUtils.getNumber(o, 'output'), cerealParse_1.ParseUtils.getNumber(o, 'timeout'), cerealParse_1.ParseUtils.getEnum(o, 'inputType', SCUIODeviceInputCondition), cerealParse_1.ParseUtils.getEnum(o, 'radioType', SCURadioType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClearToSend Model: " + e.message);
        }
    };
    return SCUClearToSend;
}());
exports.SCUClearToSend = SCUClearToSend;
var SCURadioType;
(function (SCURadioType) {
    SCURadioType[SCURadioType["conventional"] = 0] = "conventional";
    SCURadioType[SCURadioType["trunk"] = 1] = "trunk";
    SCURadioType[SCURadioType["delay"] = 2] = "delay";
    SCURadioType[SCURadioType["pushToTalk"] = 3] = "pushToTalk";
    SCURadioType[SCURadioType["trunkNonQueue"] = 4] = "trunkNonQueue";
})(SCURadioType = exports.SCURadioType || (exports.SCURadioType = {}));
var SCUTTSVoice;
(function (SCUTTSVoice) {
    SCUTTSVoice[SCUTTSVoice["Olivia"] = 0] = "Olivia";
    SCUTTSVoice[SCUTTSVoice["Amy"] = 1] = "Amy";
    SCUTTSVoice[SCUTTSVoice["Emma"] = 2] = "Emma";
    SCUTTSVoice[SCUTTSVoice["Brian"] = 3] = "Brian";
    SCUTTSVoice[SCUTTSVoice["Ivy"] = 4] = "Ivy";
    SCUTTSVoice[SCUTTSVoice["Joanna"] = 5] = "Joanna";
    SCUTTSVoice[SCUTTSVoice["Kendra"] = 6] = "Kendra";
    SCUTTSVoice[SCUTTSVoice["Kimberly"] = 7] = "Kimberly";
    SCUTTSVoice[SCUTTSVoice["Salli"] = 8] = "Salli";
    SCUTTSVoice[SCUTTSVoice["Joey"] = 9] = "Joey";
    SCUTTSVoice[SCUTTSVoice["Justin"] = 10] = "Justin";
    SCUTTSVoice[SCUTTSVoice["Kevin"] = 11] = "Kevin";
    SCUTTSVoice[SCUTTSVoice["Matthew"] = 12] = "Matthew";
    SCUTTSVoice[SCUTTSVoice["male"] = 13] = "male";
    SCUTTSVoice[SCUTTSVoice["female"] = 14] = "female";
})(SCUTTSVoice = exports.SCUTTSVoice || (exports.SCUTTSVoice = {}));
var SCUTTSConfig = /** @class */ (function () {
    function SCUTTSConfig(voice, ttsVolume, textToSpeech, rate, translations, lexicons, repetitions, waitForSpeechSynthesization) {
        this.voice = voice;
        this.ttsVolume = ttsVolume;
        this.textToSpeech = textToSpeech;
        this.rate = rate;
        this.translations = translations;
        this.lexicons = lexicons;
        this.repetitions = repetitions;
        this.waitForSpeechSynthesization = waitForSpeechSynthesization;
    }
    SCUTTSConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUTTSConfig(cerealParse_1.ParseUtils.getEnum(o, 'voice', SCUTTSVoice), cerealParse_1.ParseUtils.getNumber(o, 'ttsVolume'), cerealParse_1.ParseUtils.getString(o, 'textToSpeech'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'rate'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'translations', SCUTranslationsConfig.parse), cerealParse_1.ParseUtils.getArray(o, 'lexicons'), cerealParse_1.ParseUtils.getNumber(o, 'repetitions'), cerealParse_1.ParseUtils.getBoolean(o, 'waitForSpeechSynthesization')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUTTSConfig Model: " + e.message);
        }
    };
    return SCUTTSConfig;
}());
exports.SCUTTSConfig = SCUTTSConfig;
var SCUTTSKey;
(function (SCUTTSKey) {
    SCUTTSKey[SCUTTSKey["id"] = 0] = "id";
    SCUTTSKey[SCUTTSKey["time"] = 1] = "time";
    SCUTTSKey[SCUTTSKey["disposition"] = 2] = "disposition";
    SCUTTSKey[SCUTTSKey["cadDept"] = 3] = "cadDept";
    SCUTTSKey[SCUTTSKey["units"] = 4] = "units";
    SCUTTSKey[SCUTTSKey["type"] = 5] = "type";
    SCUTTSKey[SCUTTSKey["typeCode"] = 6] = "typeCode";
    SCUTTSKey[SCUTTSKey["typeSection"] = 7] = "typeSection";
    SCUTTSKey[SCUTTSKey["typeDesc"] = 8] = "typeDesc";
    SCUTTSKey[SCUTTSKey["description"] = 9] = "description";
    SCUTTSKey[SCUTTSKey["synopsis"] = 10] = "synopsis";
    SCUTTSKey[SCUTTSKey["addr"] = 11] = "addr";
    SCUTTSKey[SCUTTSKey["crossStreets"] = 12] = "crossStreets";
    SCUTTSKey[SCUTTSKey["boxNumber"] = 13] = "boxNumber";
    SCUTTSKey[SCUTTSKey["priority"] = 14] = "priority";
})(SCUTTSKey = exports.SCUTTSKey || (exports.SCUTTSKey = {}));
var SCUTranslationsConfig = /** @class */ (function () {
    function SCUTranslationsConfig(assignments, locations, descriptions) {
        this.assignments = assignments;
        this.locations = locations;
        this.descriptions = descriptions;
    }
    SCUTranslationsConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUTranslationsConfig(cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'assignments', SCUTranslation.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'locations', SCUTranslation.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'descriptions', SCUTranslation.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUTranslationsConfig Model: " + e.message);
        }
    };
    return SCUTranslationsConfig;
}());
exports.SCUTranslationsConfig = SCUTranslationsConfig;
var SCUTranslation = /** @class */ (function () {
    function SCUTranslation(id, pattern, replaceWith) {
        this.id = id;
        this.pattern = pattern;
        this.replaceWith = replaceWith;
    }
    SCUTranslation.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUTranslation(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'pattern'), cerealParse_1.ParseUtils.getString(o, 'replaceWith')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUTranslation Model: " + e.message);
        }
    };
    return SCUTranslation;
}());
exports.SCUTranslation = SCUTranslation;
var SCUPrinterConfig = /** @class */ (function () {
    function SCUPrinterConfig(id, printer, units, type, copies, reportType) {
        this.id = id;
        this.printer = printer;
        this.units = units;
        this.type = type;
        this.copies = copies;
        this.reportType = reportType;
    }
    SCUPrinterConfig.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUPrinterConfig(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'printer'), cerealParse_1.ParseUtils.getArray(o, 'units'), cerealParse_1.ParseUtils.getEnum(o, 'type', SCUPrintType), cerealParse_1.ParseUtils.getNumber(o, 'copies'), cerealParse_1.ParseUtils.getEnum(o, 'reportType', SCUPrintReportType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUPrinterConfig Model: " + e.message);
        }
    };
    return SCUPrinterConfig;
}());
exports.SCUPrinterConfig = SCUPrinterConfig;
var SCUPrintType;
(function (SCUPrintType) {
    SCUPrintType[SCUPrintType["alert"] = 0] = "alert";
    SCUPrintType[SCUPrintType["close"] = 1] = "close";
    SCUPrintType[SCUPrintType["both"] = 2] = "both";
})(SCUPrintType = exports.SCUPrintType || (exports.SCUPrintType = {}));
var SCUPrintReportType;
(function (SCUPrintReportType) {
    SCUPrintReportType[SCUPrintReportType["rich"] = 0] = "rich";
    SCUPrintReportType[SCUPrintReportType["text"] = 1] = "text";
    SCUPrintReportType[SCUPrintReportType["raw"] = 2] = "raw";
})(SCUPrintReportType = exports.SCUPrintReportType || (exports.SCUPrintReportType = {}));
var SCUZone = /** @class */ (function () {
    function SCUZone(id, name, units, audio, lights, bridgeMac, alertSettings, audioResetBehavior) {
        this.id = id;
        this.name = name;
        this.units = units;
        this.audio = audio;
        this.lights = lights;
        this.bridgeMac = bridgeMac;
        this.alertSettings = alertSettings;
        this.audioResetBehavior = audioResetBehavior;
    }
    SCUZone.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUZone(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getArray(o, 'units'), cerealParse_1.ParseUtils.getArray(o, 'audio'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'lights', SCUZoneLight.parse, 'throw'), cerealParse_1.ParseUtils.getStringOrNull(o, 'bridgeMac'), cerealParse_1.ParseUtils.getArrayOfSubobjectsOrNull(o, 'alertSettings', SCUAlertSetting.parse, 'warn'), cerealParse_1.ParseUtils.getEnumOrNull(o, 'audioResetBehavior', SCUAudioResetBehavior)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUZone Model: " + e.message);
        }
    };
    return SCUZone;
}());
exports.SCUZone = SCUZone;
var SCUZoneLight = /** @class */ (function () {
    function SCUZoneLight(id, switched) {
        this.id = id;
        this.switched = switched;
    }
    SCUZoneLight.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUZoneLight(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getBoolean(o, 'switched')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUZoneLight Model: " + e.message);
        }
    };
    return SCUZoneLight;
}());
exports.SCUZoneLight = SCUZoneLight;
var HueLightStateAlert;
(function (HueLightStateAlert) {
    HueLightStateAlert[HueLightStateAlert["none"] = 0] = "none";
    HueLightStateAlert[HueLightStateAlert["select"] = 1] = "select";
    HueLightStateAlert[HueLightStateAlert["lselect"] = 2] = "lselect";
})(HueLightStateAlert = exports.HueLightStateAlert || (exports.HueLightStateAlert = {}));
var SCUAlertSettingMatch = /** @class */ (function () {
    function SCUAlertSettingMatch(type, typeCode, unit, box, priority, timeStart, timeEnd) {
        this.type = type;
        this.typeCode = typeCode;
        this.unit = unit;
        this.box = box;
        this.priority = priority;
        this.timeStart = timeStart;
        this.timeEnd = timeEnd;
    }
    SCUAlertSettingMatch.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUAlertSettingMatch(cerealParse_1.ParseUtils.getStringOrNull(o, 'type'), cerealParse_1.ParseUtils.getStringOrNull(o, 'typeCode'), cerealParse_1.ParseUtils.getStringOrNull(o, 'unit'), cerealParse_1.ParseUtils.getStringOrNull(o, 'box'), cerealParse_1.ParseUtils.getStringOrNull(o, 'priority'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'timeStart'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'timeEnd')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAlertSettingMatch Model: " + e.message);
        }
    };
    return SCUAlertSettingMatch;
}());
exports.SCUAlertSettingMatch = SCUAlertSettingMatch;
var SCUAlertSetting = /** @class */ (function () {
    function SCUAlertSetting(id, match, priority, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, brightness, tts, ramp) {
        this.id = id;
        this.match = match;
        this.priority = priority;
        this.audio = audio;
        this.color = color;
        this.lightTimeout = lightTimeout;
        this.repetitions = repetitions;
        this.ttsVolume = ttsVolume;
        this.toneVolume = toneVolume;
        this.lightRamp = lightRamp;
        this.brightness = brightness;
        this.tts = tts;
        this.ramp = ramp;
    }
    SCUAlertSetting.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUAlertSetting(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobject(o, 'match', SCUAlertSettingMatch.parse), cerealParse_1.ParseUtils.getNumber(o, 'priority'), cerealParse_1.ParseUtils.getStringOrNull(o, 'audio'), cerealParse_1.ParseUtils.getStringOrNull(o, 'color'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'lightTimeout'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'repetitions'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'ttsVolume'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'toneVolume'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'lightRamp'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'brightness'), cerealParse_1.ParseUtils.getStringOrNull(o, 'tts'), cerealParse_1.ParseUtils.getEnumOrNull(o, 'ramp', SCURampLength)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUAlertSetting Model: " + e.message);
        }
    };
    return SCUAlertSetting;
}());
exports.SCUAlertSetting = SCUAlertSetting;
var SCUSelectBy;
(function (SCUSelectBy) {
    SCUSelectBy[SCUSelectBy["type"] = 0] = "type";
    SCUSelectBy[SCUSelectBy["unit"] = 1] = "unit";
})(SCUSelectBy = exports.SCUSelectBy || (exports.SCUSelectBy = {}));
var SCUJobAlert = /** @class */ (function () {
    function SCUJobAlert(synopsis, type, locationOfIncident, city, priority, box, crossStreets, units) {
        this.synopsis = synopsis;
        this.type = type;
        this.locationOfIncident = locationOfIncident;
        this.city = city;
        this.priority = priority;
        this.box = box;
        this.crossStreets = crossStreets;
        this.units = units;
    }
    SCUJobAlert.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCUJobAlert(cerealParse_1.ParseUtils.getStringOrNull(o, 'synopsis'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'type', job_1.JobType.parse), cerealParse_1.ParseUtils.getStringOrNull(o, 'locationOfIncident'), cerealParse_1.ParseUtils.getStringOrNull(o, 'city'), cerealParse_1.ParseUtils.getStringOrNull(o, 'priority'), cerealParse_1.ParseUtils.getStringOrNull(o, 'box'), cerealParse_1.ParseUtils.getStringOrNull(o, 'crossStreets'), cerealParse_1.ParseUtils.getArrayOrNull(o, 'units')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCUJobAlert Model: " + e.message);
        }
    };
    return SCUJobAlert;
}());
exports.SCUJobAlert = SCUJobAlert;
//# sourceMappingURL=scuConfig.js.map